module.exports = __webpack_public_path__ + "img/9791158882419.0cc9486f.jpg";